// extracted by mini-css-extract-plugin
module.exports = {"tier":"Tier_tier__x1ZJA","wrapper":"Tier_wrapper__e__pv","name":"Tier_name__eFgxa","description":"Tier_description__fsDPc","image":"Tier_image__gOx6F"};